<template>
  <b-container id="container" fluid>
    <div class="row">
      <div class="d-none d-md-flex col-md-4 col-lg-6 b-img"></div>
      <div class="form col-12 col-md-8 col-lg-6 bg-white
      d-flex flex-column align-items-center justify-content-center">
        <form class="text-center">
          <img src="favicon.ico" height="100px" width="100px" class="mb-4">
          <h4 class="mb-4">EMS LOGIN</h4>
          <div v-if="error" class="text-danger pb-3 font-weight-bold">WRONG CREDENTIALS!</div>
          <div class="d-flex flex-column d-md-none">
            <input
              autofocus
              class="form-control rounded-0"
              :class="{ 'border-danger': usernameMissing }"
              placeholder="Username"
              type="text"
              v-model="username"
            >
            <input
              class="form-control rounded-0"
              :class="{ 'border-danger': passwordMissing }"
              placeholder="Password"
              type="password"
              v-model="password"
            >
          </div>
          <div class="d-none d-md-flex">
            <input
              autofocus
              class="form-control rounded-0"
              :class="{ 'border-danger': usernameMissing }"
              placeholder="Username"
              type="text"
              v-model="username"
            >
            <input
              class="form-control rounded-0"
              :class="{ 'border-danger': passwordMissing }"
              placeholder="Password"
              type="password"
              v-model="password"
            >
          </div>
          <div class="d-flex mb-4">
            <b-button
              block
              class="bg-green border-0 py-2 rounded-0"
              @click="login"
            >SIGN IN</b-button>
          </div>
          <div>Forgot <router-link
            :to="{ name: 'PasswordForgotten' }"
            class="green"
          >Username / Password ?</router-link></div>
        </form>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      error: false,
      username: '',
      password: '',
      passwordMissing: false,
      usernameMissing: false,
    };
  },
  methods: {
    login() {
      // TODO ADD LOGIN
      this.error = false;
      this.passwordMissing = false;
      this.usernameMissing = false;
      if (!this.username) this.usernameMissing = true;
      if (!this.password) this.passwordMissing = true;
      if (!this.username || !this.password) {
        this.error = true;
        return;
      }
      this.$router.push('/overview');
    },
  },
};
</script>

<style scoped>
  .bg-green {
    background-color: rgb(0, 173, 94);
    color: white;
  }
  .green {
    color: rgb(0, 173, 94);
  }
  .form {
    height: 100vh;
  }
  .b-img {
    background: url("https://i.imgur.com/xX8r70i.jpg") no-repeat center;
    height: 100vh;
  }
</style>
